import React, { createContext, useReducer } from 'react';
import { InboundFilterReducer } from '../reducers/InboundFilterReducer';

export const InboundFilterContext = createContext();

const initialState = {
    allTimeRanges: [],
    selectedTimeRange: '',
    customStartDate: '',
    customStartTime: '',
    customEndDate: '',
    customEndTime: '',
    useCustomTimeRange: false,
    useShiftEndMode: false,
    stationTimezone: null,
    triggerFetch: Date.now()
};

export const InboundFilterProvider = ({ children }) => {
    const [filter, dispatch] = useReducer(InboundFilterReducer, initialState);

    return (
        <InboundFilterContext.Provider value={{ filter, dispatch }}>
            {children}
        </InboundFilterContext.Provider>
    );
};



// WEBPACK FOOTER //
// ./src/components/inbound/context/InboundFilterContext.js